import { useEffect, useState } from "react";
import { API_KEY, API_SECRET, BASEURL } from "../Constants";
import { getAccessToken } from "../../services/http-common";
import { Link } from "react-router-dom";
import Tick from "../../images/icon/tick-image.png"
import Breadcrumb from "../../components/Breadcrumb";
import Pagination from "../../components/Pagination";
interface UserInterface {
  userId?: any | null;
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  contactNumber: string;
  status: string;
  roles: [
    {
      roleId?: any | null;
      name: string;
    },
  ];
}



const AllUsers = () => {

  const [currentPage, setCurrentPage] = useState(0); // Start from 0 to match orders page
  const [perPage, setPerPage] = useState(25); // Show more users in compact view
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalUsers, setTotalUsers] = useState<number>(0);
  const [users, setUsers] = useState<UserInterface[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    fetchData(currentPage,perPage);
  }, [currentPage, perPage]); // Empty dependency array means this effect runs only once after the component mounts

  const accessToken = getAccessToken();

  const fetchData = async (page: number, perPage: number) => {
    try {
      const response = await fetch(`${BASEURL}user/`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            'X-API-SECRET': `${API_SECRET}`,
            'X-API-KEY': `${API_KEY}`,
          },       
           method: "GET",
      });
      const data = await response.json();
      const totalPages = Math.ceil(data.length / perPage);
      setTotalPages(totalPages);
      setTotalUsers(data.length); // Set the actual total count of all users
      const startIndex = page * perPage; // Use page * perPage since we start from 0
      const usersForPage = data.slice(startIndex, startIndex + perPage);
      setUsers(usersForPage);      
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };  

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    fetchData(page, perPage);
  };

  const handleItemsPerPageChange = (newPerPage: number) => {
    setPerPage(newPerPage);
    setCurrentPage(0); // Reset to first page when changing items per page
    fetchData(0, newPerPage);
  };

  return (
    <>
          <Breadcrumb pageName="Users" />

            <div className="mb-1 flex flex-wrap items-center gap-2">
            <button className="inline-block rounded bg-primary px-2 py-1 text-xs font-medium text-gray hover:bg-opacity-90">
              Total: {totalUsers}
            </button>
            <span className="inline-block rounded bg-gray-200 px-2 py-1 text-xs font-medium text-gray-700 dark:bg-gray-700 dark:text-gray-200">
              Page {currentPage + 1}/{totalPages}
            </span>
            <Link
          to="/users/add"
          className="inline-block rounded bg-success px-2 py-1 text-xs font-medium text-gray hover:bg-opacity-90"
        >
          + New
        </Link>
          </div>
          <div className="rounded border border-stroke bg-white px-2 py-1 shadow-sm dark:border-strokedark dark:bg-boxdark">
            <div className="max-w-full overflow-x-auto">
            {isLoading ? (
        <div className="flex h-32 items-center justify-center">
          <svg
            className="h-6 w-6 animate-spin text-primary"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A8.001 8.001 0 0117.709 7H15v5.373L6.373 17H6v-4.709zM20 12h-4v-.373l-5.373-5.372L15 6.627V2h5.373A8.001 8.001 0 0120 12z"
            ></path>
          </svg>
        </div>
      ) : (
              <table className="w-full table-auto text-xs">
                <thead>
                  <tr className="bg-gray-2 dark:bg-meta-4">
                    <th className="px-2 py-1 text-left text-xs font-medium text-black dark:text-white">
                      Name
                    </th>
                    <th className="px-2 py-1 text-xs font-medium text-black dark:text-white">
                      Email
                    </th>
                    <th className="px-2 py-1 text-xs font-medium text-black dark:text-white">
                      Contact
                    </th>
                    <th className="px-2 py-1 text-xs font-medium text-black dark:text-white">
                      Role
                    </th>
                    <th className="px-2 py-1 text-xs font-medium text-black dark:text-white">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user, key) => (
                    <tr key={key} className="hover:bg-gray-50 dark:hover:bg-gray-800">
                      <td className="border-b border-[#eee] px-2 py-1 dark:border-strokedark">
                        <div className="flex items-center gap-1">
                          <span className="text-xs font-medium text-black dark:text-white truncate">
                            {user.firstName} {user.lastName}
                          </span>
                          {user.status === "Active" && (
                            <img src={Tick} alt="Active" className="h-3 w-3"/>
                          )}
                        </div>
                      </td>
                      <td className="border-b border-[#eee] px-2 py-1 dark:border-strokedark">
                        <span className="text-xs text-black dark:text-white truncate block">
                          {user.email}
                        </span>
                      </td>
                      <td className="border-b border-[#eee] px-2 py-1 dark:border-strokedark">
                        <span className="text-xs text-black dark:text-white">
                          {user.contactNumber}
                        </span>
                      </td>
                      <td className="border-b border-[#eee] px-2 py-1 dark:border-strokedark">
                        {user.roles.map((role, index) => (
                          <span
                            key={index}
                            className="inline-block bg-primary/10 text-primary px-1 py-0.5 rounded text-xs font-medium"
                          >
                            {role.name === "ROLE_SUPERADMIN" && "Super"}
                            {role.name === "ROLE_CUSTOMER" && "Customer"}
                            {role.name === "ROLE_ADMIN" && "Admin"}
                          </span>
                        ))}
                      </td>

                      <td className="border-b border-[#eee] px-2 py-1 dark:border-strokedark">
                        <div className="flex items-center justify-center space-x-1">
                          <Link
                            to={`/users/details/${user.userId}`}
                            className="hover:text-primary p-1"
                            title="View Details"
                          >
                            <svg
                              className="fill-primary"
                              width="12"
                              height="12"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.99981 14.8219C3.43106 14.8219 0.674805 9.50624 0.562305 9.28124C0.47793 9.11249 0.47793 8.88749 0.562305 8.71874C0.674805 8.49374 3.43106 3.20624 8.99981 3.20624C14.5686 3.20624 17.3248 8.49374 17.4373 8.71874C17.5217 8.88749 17.5217 9.11249 17.4373 9.28124C17.3248 9.50624 14.5686 14.8219 8.99981 14.8219ZM1.85605 8.99999C2.4748 10.0406 4.89356 13.5562 8.99981 13.5562C13.1061 13.5562 15.5248 10.0406 16.1436 8.99999C15.5248 7.95936 13.1061 4.44374 8.99981 4.44374C4.89356 4.44374 2.4748 7.95936 1.85605 8.99999Z"
                                fill=""
                              />
                              <path
                                d="M9 11.3906C7.67812 11.3906 6.60938 10.3219 6.60938 9C6.60938 7.67813 7.67812 6.60938 9 6.60938C10.3219 6.60938 11.3906 7.67813 11.3906 9C11.3906 10.3219 10.3219 11.3906 9 11.3906ZM9 7.875C8.38125 7.875 7.875 8.38125 7.875 9C7.875 9.61875 8.38125 10.125 9 10.125C9.61875 10.125 10.125 9.61875 10.125 9C10.125 8.38125 9.61875 7.875 9 7.875Z"
                                fill=""
                              />
                            </svg>
                          </Link>
                          <Link to={`/users/update/${user.userId}`} className="hover:text-primary p-1" title="Edit User">
                              <svg
                                className="text-primary"
                                fill="none"
                                height="12"
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                                width="12"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                              </svg>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              )}


            </div>

            
          </div>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={totalUsers}
        itemsPerPage={perPage}
        onPageChange={handlePageChange}
        onItemsPerPageChange={handleItemsPerPageChange}
        showItemsPerPage={true}
        itemsPerPageOptions={[10, 25, 50, 100]}
      />
        
    </>
  );
};

export default AllUsers;
